const appConfig = {
  api: {
    domain: "https://api.qa.ezroi.net/api",
    timeout: 60000,
    retry: 3,
    documentRequest: "documentrequest?scope={scope}&filter={filter}",
    documentRequestSummary: "getRequestsSummaryForUser",
    uploadReferenceDocument: "referencedoc/upload?documentTypeId={docTypeId}",
    uploadEditReferenceDocument:
      "referencedoc/uploadEdit?documentTypeId={docTypeId}&docReqOrderId={orderId}",
    uploadZipFile: "referencedoc/{docId}?documentTypeId={docTypeId}",
    getUploadedZipFile: "referencedoc/{docId}/xray",
    uploadLogo: "referencedoc/upload/logo",
    downloadDocument: "referencedoc/{requestId}/download",
    downloadZipDocument: "referencedoc/{requestId}/download?isZip=true",
    downloadHippaDoc: "configuration/{orgId}/hippa/download",
    getUrlForDownload: "referencedoc/{requestId}/uri/download",
    downloadFinalDocument: "referencedoc/{requestId}/finalDocument",
    doctorFacilities: "masterdata/doctorfacility",
    attorneyOffices: "masterdata/attorneyoffice",
    attorneyOfficesV2: "masterdata/attorneyoffice/v2",
    requestTypes: "masterdata/requestType",
    recordTypes: "masterdata/recordType",
    services: "masterdata/services",
    requestStatusTypes: "masterdata/requestStatuses",
    internalStatusDomain: "masterdata/requestInternalStatuses",
    statusDomain: "masterdata/requestStatuses",
    adminRequestSummary: "dashboard/requestSummary",
    requestSummaryByorgId: "dashboard/documents",
    getRequestCountsByStatus: "dashboard/requestCountsByStatus",
    getAdminEntityCounts: "dashboard/adminEntityCounts",
    govertmentIdTypes: "masterdata/govertmentIdType",
    invoiceFeeTypes: "masterdata/feetypes",
    getXrayBodyParts: "masterdata/xrayBodyParts",
    getXrayCategories: "masterdata/xrayCategories",
    admin: {
      documentRequest: "documentrequest?filter={filter}",
      documentRequestSummary: "getRequestsSummaryForUser",
      documentRequestDetails: "documentrequest/{documentRequestId}",
      documentRequestStatus: "documentrequest/{documentRequestId}/status",
      documentRequestXrayBodyParts: "masterdata/xrayBodyParts",
      // documentRequestUpdateXrayBreakdown: "backoffice/{documentRequestId}/"
      documentRequestXrayBreakdown:
        "backoffice/{documentRequestId}/xrayExamBDDetails", //xrayExamInfo", // (getXray Exam info) api
      documentRequestUserFiles:
        "documentrequest/{documentRequestId}/getUserUploadedDocs",
      documentRequestAdminFiles:
        "documentrequest/{documentRequestId}/getAdminUploadDocs",
      documentRequestUploadFiles:
        "referencedoc/upload?documentTypeId={documentId}&docReqOrderId={orderId}",
      bulkactions: "bulk-actions/upload",
      bulkUploadedFiles: "bulk-actions",
      bulkUploadXrayTasks: "bulk-actions/xray",
      documentRequestUnpaid: "dashboard/unpaidAmount",
      documentRequestUnpaidSummary: "dashboard/unpaidAmount/summary",
      documentRequestUnpaidList: "dashboard/unpaidList",
      documentRequestInvoiceDetails:
        "backoffice/{documentRequestId}/invoiceItems",
      getPaidInvoice: "documentrequest/paidInvoice",
      getPaidFilterInvoice: "documentrequest/paidFilterInvoice",
      documentRequestInvoiceInfo: "backoffice/{documentRequestId}/invoiceinfo",
      documentRequestInvoiceDetailsUpdate:
        "backoffice/{documentRequestId}/patchInvoice",
      documentRequestCreateCheckPayment:
        "backoffice/{documentRequestId}/createCheckPayment",
      documentRequestCreateXrayCheckPayment:
        "backoffice/{documentRequestId}/createXrayPayment",
      documentRequestUpdateOrderDetails:
        "backoffice/{documentRequestId}/updateDocumentRequestDetails",
      getMessages: "documentrequest/{requestId}/messageThreads",
      sendMessage: "documentrequest/{requestId}/messageThread",
      SubmitDocumentRequest: "documentrequest/{requestId}/Submit",
      reSubmitDocumentRequest: "documentrequest/{requestId}/reSubmit",
      generateInvoice: "backoffice/{documentId}/generateInvoice",
      generateInvoicePost: "backoffice/generateInvoice",
      generateDeclarationOfRecord:
        "documentrequestorder/{documentId}/recordDeclaration",
      certifyNoRecords: "backoffice/{documentId}/certifyNoRecords",
      getServiceFees:
        "fee/getServiceFees?processingOrgId={processingOrgId}&recordTypeId={recordTypeId}&requestTypeId={requestTypeId}&invoiceDefaultFees={invoiceDefaultFees}&docId={docId}&isCnr={isCnr}",
      getUniversalServiceFees: "fee/getUniversalServiceFees",
      writeOffPayment: "backoffice/{requestId}/writeOffPayment",
      getPaymentHistory: "backoffice/{userId}/paymentHistory",
      getPaymentHistoryByDocRequestId:
        "backoffice/{requestId}/getPaymentHistoryByDocRequestId",
      documentRequestDeleteUploadedFile: "referencedoc/{id}",
      addServiceFee: "fee/createServiceFee",
      addRecordList: "recordtypes",
      addRequestList: "requestTypes",
      getAllServiceList: "fee",
      updateServiceFee: "fee/updateServiceFee",
      getAllinvoices: "fee/invoices",
      updateDoctorFacilityStaus: "doctorfacility/change/status/{id}",
      deleteServiceFee: "fee/{id}",
      deleteFinalDocument: "documentrequestorder/{id}/recordDeclaration",
      pendingDoctorFacilityList: "admin/pending/facilities/{type}",
      updateFacilityStatus: "admin/facilities/status/{id}",
      getNotes: "note/{docId}",
      addNote: "note",
      getDFRequestTypes: "requesttypes/{orgId}",
      getDFRecordTypes: "recordtypes/{orgId}",
      publicRecordTypes: "recordtypes/public",
      publicAdvanceFee: "configuration/public",
      getStripeIdByOrgId: "backoffice/stripeId/{id}",
      getTaskLogs: "bulk-actions/logs/{taskId}",
      support: "support",
      createFeeDueItem: "platformFee",
      platformFeeStatus: "platformFee/request/status",
      updateFeeDueItems: "platformFee/due/status",
      createFeePaymentRequest: "platformFee/request",
    },
  },
  pusher: {
    key: "6e32c763f482c5d98748",
    cluster: "ap2",
    enabled: true,
  },
  auth: {
    login: "user/login",
    Validate: "user/verifyUser",
    otpvalidate: "user/sendVerifyotp",
    verifyOtp: "user/verifyOtp",
    verifyCaptcha: "user/verifycaptcha",
    fetchTwoFactorAnthentication: "authenticator/generate",
    verifyTwoFactorAnthentication: "authenticator/verify",
    authenticatorverify: "authenticator/verifyOtp",
    recoveryCode: "authenticator/verifyRecoveryCode",
    changePassword: "user/changepassword",
    disable2FA: "user/disable2fa",
    reset2FA: "user/reset2fa",
    enable2FA: "user/enable2fa",
    signup: "user/register",
    sendOTP: "user/sendotp",
    resetPassword: "user/resetpassword",
    verifyEmail: "user/verifyemail",
    isEmailExists: "user/checkemailexists",
    forgotPassword: "user/forgotpassword",
    verifyToken: "user/verifytoken",
    setPassword: "user/setpassword",
    logout: "user/logout",
    stripeSetupLink: "stripe/stripeSetupLink",
  },
  patient: {
    documentRequest: "documentrequest?filter={filter}",
    documentRequestSummary: "documentrequest/count",
    notifications: "notification/?filter={filter}",
    userInformation: "user/{userId}",
    updateUserDetails: "user/{userId}",
    updateCompanyDetails: "company/{companyId}",
    getPaymentHistory: "user/{requestId}/paymentHistory",
    getMessages: "documentrequest/{requestId}/messageThreads",
    sendMessage: "documentrequest/{requestId}/messageThread",
    getOrderDetails: "documentrequest/{requestId}",
    getDocumentUploadedByUser:
      "documentrequest/{requestId}/getUserUploadedDocs",
    getDocumentUploadedByAdmin:
      "documentrequest/{requestId}/getAdminUploadDocs",
    getXrayDetails: "backoffice/{requestId}/xrayExamBDDetails",
    getInvoiceDetails: "backoffice/{documentRequestId}/invoiceItems",
    getPaymentHistoryDetailsByDocRequestId:
      "backoffice/{requestId}/getPaymentHistoryByDocRequestId",
    documentRequestInvoiceInfo: "backoffice/{documentRequestId}/invoiceinfo",
    getServiceFees:
      "fee/getServiceFees?processingOrgId={processingOrgId}&recordTypeId={recordTypeId}&requestTypeId={requestTypeId}&invoiceDefaultFees={invoiceDefaultFees}&docId={docId}&isCnr={isCnr}",
    getUniversalServiceFees: "fee/getUniversalServiceFees",
    getXrayDocs: "referencedoc/{documentRequestId}/xray/docs",
    // orderList:'user/{requestId}/documentRequests'  //replaced with documnet request
  },
  newera: {
    addDoctorFacility: "doctorfacility",
    getDoctorFacilityList: "doctorfacility",
    getDoctorFacilityListV2: "doctorfacility/v2",
    getBackOfficeAddress: "backoffice/address/{orgId}",
    updateDoctorFacility: "doctorfacility",
    getCompanyList: "company",
    getCompanyDetails: "company/user/{requestId}",
    getProfessionalDetails: "company/professional/{requestId}",
    getCustomerDetails: "customer/user/{requestId}",
    getCompanyUserList: "company/{requestId}/users",
    getCustomerUserList: "customer/{requestId}",
    addCompany: "company",
    addCompanyUser: "company/add-user",
    updateDocumentRequestDetails: "backoffice/updateDocumentRequestDetails",
    updateprofessionaldetails: "company/{requestId}",
    updateCompanyUserDetails: "company/user/{requestId}",
    getDoctorFacilityDetails: "doctorfacility/{requestId}",
    doctorWithOrgId: "doctorfacility/orgId/{orgId}",
    attorneyWithOrgId: "attorneyOffice/orgId/{orgId}",
    doctorFaclilitySortOrgId: "doctorfacility/orgId/{orgId}/filter",
    attorneyFaclilitySortOrgId: "attorneyOffice/orgId/{orgId}/filter",
    getBasicUserList: "masterdata/users",
    getDocumentProofTypes: "masterdata/getdocumenttypes",
    getRequestingPartyDetails: "company/{requestId}",
    getAllUsersList: "user",
    getAllPatientsList: "patients",
    getUserDetailsById: "user/{userId}",
    checkDuplicateDoctorEmail: "doctorfacility/checkemailexists",
    checkDuplicateDoctorEin: "doctorfacility/checkeinexists",
    checkCompanyofEin: "company/checkeinexists",
    checkCompanyNmaeExist: "company/checkcompanynameexists",
    addxraybodyparts: "xraybodyparts",
    addXrayCategories: "xraycategories",
    deleteInvoice: "backoffice/{documentRequestId}/invoice/{invoiceId}",
    backOfficeAdmin: "backofficeadmin",
    insuranceCompany: "insurancecompany",
    attorneyOffice: "attorneyOffice",
    getBackOfficeList: "backofficeadmin",
    getBackOfficeListV2: "backofficeadmin/v2",
    getAttorneyList: "attorneyOffice",
    getAttorneyListV2: "attorneyOffice/v2",
    getInsuranceCompanyList: "insurancecompany",
    getInsuranceCompanyListV2: "insurancecompany/v2",
    getBackOfficeDetails: "backofficeadmin/{requestId}",
    updateBackOffice: "backofficeadmin",
    updateInsuranceCompanyDetails: "insurancecompany/{requestId}",
    getInsuranceCompanyDetails: "insurancecompany/{requestId}",
    getAttorneyOfficeDetails: "attorneyOffice/{requestId}",
    updateAttorneyOfficeDetails: "attorneyOffice",
    getUsersByType: "backofficeadmin/{userType}/list",
    getUsersByTypeV2: "backofficeadmin/{userType}/list/v2",
    publicDoctorFacilites: "doctorfacility/public",
    publicAttorneyOffice: "/attorneyOffice/public",
    getRecordTypes: "recordtypes",
    getRequestTypes: "requesttypes",
    getConfiguration: "configuration",
    getMyCustomerList: "customer",
    getOrgConfiguration: "configuration/{orgId}",
    getFacilityDetails: "doctorfacility/facility/{type}/{id}",
    updateUserStatus: "backoffice/user/{requestId}",
    ownerLogo: "backoffice/logo/{type}/{id}",
    getActivityList: "activity",
    getAllTransactionList: "transaction/all",
    getSuccessTransactionList: "transaction/success",
    getPaymentList: "payment",
    getAllFeeDueItems: "platformFee/all",
    getAllFeeRequests: "platformFee/request/all",
    getRequestIdDetails: "platformFee/request/{requestId}",
    getRequestIditems: "platformFee/request/{requestId}/items",
    createPaymentIntentForFeePayments: "platformFee/intent/bulk",
    companyEmployees: "company/employees",
    resendInvite: "company/resend",
    systemLogs: "masterdata/systemlogs",
    userLogs: "masterdata/userlogs",
    getCannedMessages: "cannedmessages",
    getCannedMessageById: "cannedmessages/{id}",
    addCannedMessages: "cannedmessages/add",
    updateCannedMessages: "cannedmessages/{id}",
    paymentSummary: "paymentSummary/{id}",
    createPaymentSummary: "paymentSummary",
    getRecordSummarybyId: "paymentSummary/orderId/{id}",
    updatePaymentSummaryRecords: "paymentSummary/updateStatus",
    getBackOfficeFacilities: "reports/facilities",
    generateReport: "reports",
    getReports: "reports",
    downloadReport: "reports/{reportId}",
    addRecordPayment: "/backoffice/createNewRecordPayment",
  },
  payment: {
    createAdvancePaymentIntent: "payment/advance-payment-intent/bulk",
    createPaymentIntent: "payment/payment-intent",
    createPaymentIntentBulk: "payment/payment-intent/bulk",
    createXRayPaymentIntent: "payment/xray-payment-intent",
    getpaymnetTrackById: "payment/payment-track-id",
    getpaymentTrackByIntentId: "payment/payment-track-intentId",
    skipAdvanceFee: "payment/skip-advance-fee",
    stripePublishableKey:
      "pk_test_51UKcij2LfzeJcPU149VLgMYyKBOVt0XFD4o5UUe3nks5VKt6XDDXB071EaJhXXRJ2gEQkDUxjUvDiWRjYlrw4sOe00ABfA9KvM",
  },
  stripe: {
    getAccountDetails: "stripe/getAccountDetails",
    sendRefreshAccountLinkEmail: "stripe/sendRefreshAccountLinkEmail",
  },
  v2: {
    getAllActivities: "v1/activity/admin/all",
    getAdminActivities: "v1/activity",
    adminActivityLogs: "v1/admin/activity",
    adminActivityLogFilters: "v1/admin/activity/filters",
    getSupportAttachment: "v1/support-messages/attachment/{id}/{index}",
    getSupportAttachmentUrl: "v1/support-messages/{id}/attachments/{index}",
    CannedMessagesCount:"v1/canned-messages/dashboard/counts",
    search:"v1/search",
    updateAdminReminder:"v1/admin/reminders/{id}",
    createAdminReminder:"v1/admin/reminders",
    getAdminReminder:"v1/admin/reminders/{id}",
    getNextFacilityAccount:"v1/organizations/{type}/next",
    getPreviousFacilityAccount:"v1/organizations/{type}/previous",
    getNextRejectRequest: "v1/admin/accounts/rejected/next",
    getPreviousRejectRequest: "v1/admin/accounts/rejected/previous",
    getNextPendingRequest: "v1/admin/accounts/pending/next",
    getPreviousPendingRequest: "v1/admin/accounts/pending/previous",
    getPreviousOrganization: "v1/admin/organizations/type/{type}/previous",
    getNextOrganization: "v1/admin/organizations/type/{type}/next",
    getAllUsersByAccountId: "v1/users/account/{accountId}",
    testEmailIntegrationforUser: "v1/integrations/test/user/type/{type}",
    testEmailIntegration: "v1/integrations/test/type/{type}",
    archiveCannedMessage: "v1/canned-messages/archived/{id}",
    sendGeneralEmail: "v1/orders/sendGeneralEmail",
    getEmailIntegrationsForUser: "v1/integrations/type/EMAIL/user",
    postSmtpForUser: "v1/integrations/type/user",
    putEmailSettingsById: "v1/email-settings/{id}",
    getEmailSettings: "v1/email-settings",
    postEmailSettings: "v1/email-settings",
    postIntegrationByProvider: "v1/integrations/user/{provider}",
    postIntegrationAccountByProvider: "v1/integrations/account/{provider}",
    getLoginUrlByProvider: "v1/integrations/login-url/{provider}",
    getHl7Integration: "v1/integrations/type/EHL",
    getFaxIntegrationDetails: "v1/integrations/faxIntegration",
    getRingCentralAccount: "v1/integrations/RINGCENTRAL/account",
    faxIntegration: "v1/integrations",
    hl7Integration: "v1/integrations",
    deleteEmailIntegrations: "v1/integrations/{id}",
    deleteUserEmailIntegrations:
      "v1/integrations/{id}/type/EMAIL/user/{userId}",
    getEmailIntegrations: "v1/integrations/type/Email/account",
    smtpIntegration: "v1/integrations/type/account",
    getEmailIntegrationsById: "v1/integrations/{id}",
    sendFax: "v1/orders/fax/{orderId}",
    bodyPartsFacilityArchiveData: "v1/xray-body-parts/archived/{id}",
    serviceMappingFacilityArchiveData: "v1/service-mapping/archived/{id}",
    serviceListFacilityArchiveData: "v1/service/archived/{id}",
    requestTypeFacilityArchiveData: "v1/request-type/archived/{id}",
    recordTypeFacilityArchiveData: "v1/record-type/archived/{id}",
    serviceMappingArchiveData: "v1/admin/service-mapping/archived/{id}",
    serviceListArchiveData: "v1/admin/service/archived/{id}",
    recordTypeArchiveData: "v1/admin/record-type/archived/{id}",
    requestTypeArchiveData: "v1/admin/request-type/archived/{id}",
    archiveData: "v1/admin/xray-body-parts/archived/{id}",
    getSupportMessages: "v1/support-messages/order/{orderId}",
    putByIdSupportMessages: "v1/support-messages/{id}",
    getTickets: "v1/support-messages/tickets",
    getTicketById: "v1/support-messages/tickets/{id}",
    postSupportMessages: "v1/support-messages",
    getAdminPaymentTransactions: "v1/transaction/admin/filter",
    updateFacilityStatus: "v1/admin/organizations/activation/{id}",
    updateBackofficeStatus: "v1/admin/accounts/activation/{id}",
    getAdminStatus: "v1/admin/users/{id}/user-activation",
    changeEmployeeStatus: "v1/customer/{id}/active",
    updateEmployeeStatus: "v1/users/{id}/user-activation",
    getOnboardingServiceMapping: "v1/admin/service-mapping/onboarding",
    getConsolidatedServiceMapping: "v1/admin/service-mapping/consolidatedOnboarding",
    saveOnboardingServiceMapping: "v1/onboarding/service-mapping",
    getOnboardingPackageBilling: "v1/onboarding/package-billing",
    getOnboardingFlows: "v1/admin/flow-type/onboarding",
    saveOnboardingFlows: "v1/onboarding/flows",
    getFlowReferenceIds: "v1/flow-type/reference-ids",
    getOnboardingRequestType: "v1/admin/request-type/onboarding",
    getOnboardingBodyParts: "v1/admin/xray-body-parts/onboarding",
    saveOnboardingRequestType: "v1/onboarding/request-type",
    saveOnboardingRecordType: "v1/onboarding/record-type",
    saveOnboardingServices: "v1/onboarding/services",
    saveOnboardingBodyParts: "v1/onboarding/xray-body-parts",
    getOnboardingRecordTypes: "/v1/admin/record-type/onboarding",
    getOnbordingServices: "v1/admin/service/onboarding",
    adminLogin: "v1/auth/admin/login",
    getOrderDetails: "/v1/orders/requester/order-details/{id}",
    medicalReqistration: "v1/register/medical-facility",
    lawOfficeRegistration: "v1/register/law-office",
    backOfficeRegistration: "v1/register/back-office",
    insuranceCompanyRegistration: "v1/register/insurance-company",
    patientRegistration: "v1/register/patient",
    professionalRegistration: "v1/register/professional-company",
    login: "v1/auth/login",
    resendEmailVerification: "v1/auth/resend-email-verification",
    getProfileDetails: "v1/auth/profile",
    updateProfileDetails: "v1/auth/profile/update",
    verifiedLogin: "v1/auth/verified-login",
    updateAuthDomain: "v1/auth/domain",
    verifyLoginPassword: "v1/auth/verify-login-password",
    refreshSession: "v1/auth/refresh",
    signout: "v1/auth/signout",
    adminforgotPassword: "v1/admin-verification/forgot-password",
    adminResetPassword: "v1/admin-verification/reset-password",
    forgotPassword: "/v1/verification/forgot-password",
    resetPassword: "v1/verification/reset-password",
    accountDetails: "v1/accounts/{id}",
    getAdminRecordTypes: "/v1/admin/record-type/onboarding",
    getAdminRequestTypes: "/v1/admin/request-type/onboarding",
    getAdminServiceMapping: "/v1/admin/service-mapping/onboarding",
    getAdminServices: "/v1/admin/service/onboarding",
    getAdminBodyParts: "/v1/admin/xray-body-parts/onboarding",
    getAdminConfig: "/v1/admin/configuration",
    updateAdminConfig: "/v1/admin/configuration/{id}",
    updatePrefixes: "/v1/accounts/onboarding/prefixes",
    createBulkRecordTypes: "/v1/record-type/onboarding",
    createBulkRequestTypes: "/v1/request-type/onboarding",
    createBulkServiceMapping: "/v1/service-mapping/onboarding",
    createBulkServices: "/v1/service/onboarding",
    createBulkBodyParts: "/v1/xray-body-parts/onboarding",
    onBoardingPaymentSetting: "v1/configuration/onboarding",
    loadDefaults: "v1/load-default",
    getAccountDetails: "v1/accounts/{id}",
    getorganizationsbyNature: "v1/admin/organizations/type/{nature}",
    getAccountsbyNature: "v1/admin/accounts/nature/{nature}",
    getUserLogs: "v1/userActivity",
    getAuditLogs: "v1/admin/audit-activity",
    getAllAccounts: "v1/admin/accounts",
    getAllPatient: "v1/admin/patients",
    getAdminUsers: "/v1/users",
    getPendingFacilities: "/v1/admin/accounts/pending/{nature}",
    getRejectedFacilities: "/v1/admin/accounts/rejected/{nature}",
    getPendingSignUPFacilities: "/v1/admin/accounts/PendingSignUp/{nature}",
    adminRecordTypes: "/v1/admin/record-type",
    adminRequestType: "v1/admin/request-type",
    adminFlowType: "/v1/admin/flow-type",
    adminaddFlowType: "/v1/admin/flow-type",
    admineditFlowType: "/v1/admin/flow-type/{id}",
    admingetFlowTypeById: "/v1/admin/flow-type/{id}",
    adminFlowTypeArchive: "/v1/admin/flow-type/archived/{id}",
    adminServiceList: "/v1/admin/service",
    adminServiceMapping: "/v1/admin/service-mapping",
    adminPackageBuildings: "/v1/admin/package-buildings",
    adminPackageBuildingById: "/v1/admin/package-buildings/{id}",
    adminPackageBuildingLineItems: "/v1/admin/package-building-line-items",
    adminPackageBuildingLineItemById: "/v1/admin/package-building-line-items/{id}",
    adminPackageBuildingLineItemsByPackage:
      "/v1/admin/package-building-line-items/package/{packageBuildingId}",
    adminPackageBuildingLineItemConfigs:
      "/v1/admin/package-building-line-item-configs",
    adminPackageBuildingLineItemConfigById:
      "/v1/admin/package-building-line-item-configs/{id}",
    adminPackageBuildingLineItemConfigsByLineItem:
      "/v1/admin/package-building-line-item-configs/line-item/{lineItemId}",
    packageBuildings: "/v1/package-buildings",
    packageBuildingById: "/v1/package-buildings/{id}",
    packageRecordTypesByOrgId:
      "/v1/package-buildings/organization/{orgId}/record-types",
    packageBuildingLineItems: "/v1/package-building-line-items",
    packageBuildingLineItemById: "/v1/package-building-line-items/{id}",
    packageBuildingLineItemsByPackage:
      "/v1/package-building-line-items/package/{packageBuildingId}",
    packageBuildingLineItemConfigs: "/v1/package-building-line-item-configs",
    packageBuildingLineItemConfigById:
      "/v1/package-building-line-item-configs/{id}",
    packageBuildingLineItemConfigsByLineItem:
      "/v1/package-building-line-item-configs/line-item/{lineItemId}",
    masterDataCsvTemplate: "/v1/admin/master-data/{entity}/template",
    masterDataCsvExport: "/v1/admin/master-data/{entity}/export",
    masterDataCsvImport: "/v1/admin/master-data/{entity}/import",
    masterDataReleases: "/v1/admin/master-data-releases",
    masterDataReleaseById: "/v1/admin/master-data-releases/{id}",
    masterDataReleasePublish: "/v1/admin/master-data-releases/{id}/publish",
    masterDataReleaseArchive: "/v1/admin/master-data-releases/{id}/archive",
    masterDataReleaseTenants: "/v1/admin/master-data-releases/{id}/tenants",
    masterDataReleaseLogs: "/v1/admin/master-data-releases/{id}/logs",
    masterDataReleasePushImported: "/v1/admin/master-data-releases/push-imported",
    masterDataReleasePushableCatalog:
      "/v1/admin/master-data-releases/pushable-catalog",
    masterDataReleasesPending: "/v1/master-data-releases/pending",
    masterDataReleasesPendingCount: "/v1/master-data-releases/pending/count",
    masterDataReleasePull: "/v1/master-data-releases/{id}/pull",
    adminXraybodypartsList: "/v1/admin/xray-body-parts",
    adminXraybodypartsWithFeeList: "/v1/admin/xray-body-parts/with-fee",
    adminaddXrayBodyParts: "v1/admin/xray-body-parts",
    editAdminXrayBodyParts: "/v1/admin/xray-body-parts/{id}",
    admingetXrayBodyPartById: "/v1/admin/xray-body-parts/{id}",
    getXrayBodyPartById: "/v1/xray-body-parts/{id}",
    adminaddServiceList: "/v1/admin/service",
    admineditServiceList: "/v1/admin/service/{id}",
    getAdminServiceListById: "/v1/admin/service/{id}",
    admingetRequestTypeById: "/v1/admin/request-type/{id}",
    admineditRequestType: "/v1/admin/request-type/{id}",
    adminaddRequestType: "/v1/admin/request-type",
    admingetRecordTypeById: "/v1/admin/record-type/{id}",
    admineditRecordType: "/v1/admin/record-type/{id}",
    adminaddRecordType: "/v1/admin/record-type",
    getadminServiceMappingById: "/v1/admin/service-mapping/full-object/{id}",
    adminaddServiceMapping: "/v1/admin/service-mapping",
    getParentServices: "v1/admin/service-mapping/parent-services",
    admineditServiceMapping: "/v1/admin/service-mapping/{id}",
    admindeleteServiceMapping: "/v1/admin/service-mapping/{id}",
    getAdminCannedMessagesById: "/v1/admin/canned-messages/{id}",
    addAdminCannedMessage: "/v1/admin/canned-messages",
    getAdminCannedMessages: "/v1/admin/canned-messages",
    archiveAdminCannedMessage: "/v1/admin/canned-messages/archived/{id}",
    updateAdminCannedMessage: "/v1/admin/canned-messages/{id}",
    cannedMessageArchiveData: "/v1/admin/canned-messages/archived/{id}",
    adminCreateBackOffice: "/v1/admin/back-office",
    adminCreateAddCompany: "/v1/admin/users",
    updateUserStatus: "/v1/users/status/{id}",
    adminCreateAddAttorney: "/v1/admin/law-office",
    adminCreateAddDoctorFacility: "/v1/admin/medical-facility",
    admingetCompanyDetails: "/v1/admin/users/{id}",
    getCompanyUserDetails: "/v1/admin/accounts/id/{id}",
    updateCompanyUserDetails: "/v1/admin/accounts/{id}",
    updateCompanyEmployee: "/v1/admin/users/{id}",
    getAdminCompanyList: "v1/admin/users",
    getUserDetails: "v1/users/{id}",
    generateAuthenticatorQR: "v1/authenticator-details",
    setUpAuthenticator: "v1/authenticator-details/setup-authenticator",
    validateAuthenticator: "v1/authenticator-details/validate-authenticator",
    verify2faRecoveryCode: "v1/authenticator-details/validate-recoveryCode",
    adminGenerateAuthenticatorQR: "v1/admin/authenticator-details",
    adminSetUpAuthenticator:
      "v1/admin/authenticator-details/setup-authenticator",
    adminValidateAuthenticator:
      "v1/admin/authenticator-details/validate-authenticator",
    adminVerify2faRecoveryCode:
      "v1/admin/authenticator-details/validate-recoveryCode",
    resendVerifyAccountEmail: "v1/admin/accounts/resend-verify-account/{id}",
    reset2FA: "v1/authenticator-details/{id}",
    disable2FA: "v1/users/userCredentials/{id}/disable-2fa",
    enable2FA: "v1/users/userCredentials/{id}/enable-2fa",
    adminVerifiedLogin: "v1/admin/verified-login",
    adminApproved: "v1/admin/accounts/{id}/approve",
    adminAccountCanceled: "v1/admin/accounts/canceled",
    getRolesByAccount: "v1/role/account",
    getadminFacilityDetails: "v1/admin/accounts/id/{id}",
    getadminAccountDetails: "v1/admin/accounts/id/{id}",
    getAdminEarningDetailsById:"v1/admin/account-based-earnings/id/{id}",
    getadminMedicalFacilityDetails:
      "v1/admin/organizations/{id}/organization-address",
    getadminLawOfficeDetails:
      "v1/admin/organizations/{id}/organization-address",
    adminUpdateFacilityDetails: "v1/admin/accounts/{id}",
    adminUpdateAccountDetails: "v1/admin/accounts/{id}",
    adminUpdateMedicalFacilityDetails: "v1/admin/organizations/{id}",
    getRolesByAdmin: "v1/admin-role",
    transferOwner: "v1/admin/users/transfer-ownership",
    transferUserOwner: "v1/users/transfer-ownership",
    ownershipTransferRequestOtp: "v1/ownership-transfer-otp/request-otp",
    ownershipTransferResendOtp: "v1/ownership-transfer-otp/resend-otp",
    ownershipTransferVerifyOtp: "v1/ownership-transfer-otp/verify-otp",
    createMedicalFacility: "v1/organizations",
    createLawOffice: "v1/organizations",
    getMedicalFacility: "v1/organizations/medical-facility",
    getLawOffice: "v1/organizations/law-office",
    getMedicalFacilityDetails: "/v1/organizations/{id}",
    updateMedicalFacilityDetails: "/v1/organizations/{id}",
    getRecordTypes: "/v1/record-type",
    getRequestTypes: "v1/request-type",
    getServiceList: "/v1/service",
    getServiceMapping: "/v1/service-mapping",
    getXraybodypartsList: "/v1/xray-body-parts",
    getXraybodypartsWithFeeList: "/v1/xray-body-parts/with-fee",
    getCannedMessages: "/v1/canned-messages",
    getConfig: "/v1/configuration/{id}",
    updatePatientDetails: "/v1/admin/accounts/{id}/patient",
    updateConfig: "/v1/configuration/{id}",
    getXrayCategories: "/v1/xray-body-parts/categories",
    addXrayBodyParts: "/v1/xray-body-parts",
    editXrayBodyParts: "/v1/xray-body-parts/{id}",
    addServiceList: "/v1/service",
    editServiceList: "/v1/service/{id}",
    getServiceListById: "/v1/service/{id}",
    getRequestTypeById: "/v1/request-type/{id}",
    editRequestType: "/v1/request-type/{id}",
    addRequestType: "/v1/request-type",
    flowType: "/v1/flow-type",
    addFlowType: "/v1/flow-type",
    editFlowType: "/v1/flow-type/{id}",
    getFlowTypeById: "/v1/flow-type/{id}",
    flowTypeArchive: "/v1/flow-type/archived/{id}",
    resolveFlowType: "/v1/flow-type/resolve",
    getRecordTypeById: "/v1/record-type/{id}",
    editRecordType: "/v1/record-type/{id}",
    addRecordType: "/v1/record-type",
    editServiceMapping: "/v1/service-mapping/{id}",
    deleteServiceMapping: "/v1/service-mapping/{id}",
    addServiceMapping: "/v1/service-mapping",
    getServiceMappingById: "/v1/service-mapping/full-object/{id}",
    getCannedMessagesById: "/v1/canned-messages/{id}",
    addCannedMessage: "/v1/canned-messages",
    updateCannedMessage: "/v1/canned-messages/{id}",
    getParentService: "/v1/service-mapping/parent-services",
    verifyToken: "v1/auth/verify",
    adminVerifyToken: "v1/auth/admin-verify",
    verifyOtp: "v1/auth/verify-otp",
    resendOTP: "v1/auth/resend-otp",
    getAdminProfileById: "v1/admin/users/{id}",
    AdminupdateProfile: "v1/admin/users/profile",
    getProfileById: "v1/users/profile/{id}",
    updateProfile: "v1/users/{id}",
    changePassword: "v1/users/change-password",
    adminchangePassword: "/v1/admin/users/change-password",
    accountUsers: "v1/users/employess",
    accountUserDetails: "v1/users/employees/{id}",
    accountRoles: "v1/role/account",
    createEmployee: "v1/users",
    updateEmployee: "v1/users/employee/{id}",
    getAdminPendingRequestDetails: "v1/accounts/{id}",
    updateAdminPendingRequestDetails: "v1/accounts/account-address/{id}",
    getRequestProcessorOrdersByInternalStatus:
      "v1/orders/requester-processor/status/{status}",
    getRequestorOrdersByRequestStatus: "v1/orders/requester/status/{status}",
    getAllRequest: "v1/orders/order-details/request-processor",
    getRequestorOrdersWithFilesByRequestStatus:
      "v1/orders/requester/order-files/{status}",
    getNewRequestProcessorDocuments:
      "v1/orders/requester-processor/new-request",
    getByAccountIdwithAddress: "v1/organizations/{id}/account-configuration",
    getAccountById: "v1/admin/accounts/id/{id}",
    getEarningDetailsById:"v1/orders/account-based-earnings",
    updateAccountInfo: "v1/accounts/account-address/{id}",
    getSettingAccountById: "v1/accounts/{id}",
    getXrayCategoriesEnums: "v1/xray-body-parts/enum/categories",
    getAdminXrayCategoriesEnums: "/v1/admin/xray-body-parts/enum/categories",
    getXrayBodyPartEnums: "v1/admin/configuration/field",
    updateGeneral: "v1/accounts/prefixes",
    getRequestProcessorFiles: "v1/files/requestProcessor/{orderId}",
    getRequesterFiles: "v1/files/requester/{orderId}",
    supportEmail: "v1/support",
    getApprovedReports: "v1/reports/facilities",
    getReportsHistory: "v1/reports",
    generateReport: "v1/reports",
    downloadReports: "v1/reports/{id}",
    updateAccountAndUser: "v1/admin/accounts/pending-sing-up/{id}",
    organizations: {
      getOrganizationsByType: "v1/organizations/type/{type}",
      getOrganizationsByAccount: "v1/organizations/account/{accountId}",
      getOrganizationDetailswithAddress:
        "/v1/organizations/{id}/organization-address",
      updateFacilityStatus: "v1/organizations/activation/{id}",
    },
    recordTypes: {
      getRecordTypesByOrgId: "v1/record-type/organization/{orgId}",
      getRecordTypesReferenceIds: "v1/record-type/reference-ids",
    },
    payments: {
      getPaymentDetails: "v1/transaction",
      getTransitionDetails: "v1/transaction",
      paymentIntent: "v1/webhooks/payment-intent/{invoiceId}",
      confirmPaymentIntent: "v1/webhooks/payment-intent/{invoiceId}/confirm",
      multiplePaymentIntent: "v1/webhooks/payment-intent-multiple",
      getPaymentIntentDetails: "v1/webhooks/{id}",
      getPaymentHistory: "v1/transaction/order/{orderId}",
      getBulkLogs: "v1/bulk-job/{id}",
      searchTransactions: "v1/transaction/filter",
    },
    hl7: {
      getPatient: "v1/ehl/{orgId}",
      getPatintDocument: "v1/ehl/{orgId}/documents/{patientId}",
      getDocumentByReferenceId: "v1/ehl/{orgId}/documents/{docId}/content",
      getPatientbyFhirId: "v1/ehl/{orgId}/fhir/{fhirId}",
      bulkUplaodFilesEHR: "v1/ehl/bulkUploadEHRFiles",
      getOrganizationsEHLDetails: "v1/ehl/organization/{orgId}"
    },
    platFormFee: {
      getAllFeeDueItems: "v1/platform-fee/due-item",
      getadminAllFeeDueItems: "v1/platform-fee/admin/due-item",
      getadminAllPaidItems: "v1/platform-fee/admin/request/all",
      createFeePaymentRequest: "v1/platform-fee/request",
      getAllFeeRequests: "v1/platform-fee/request/all",
      getRequestDetails: "v1/platform-fee/request-item/{id}",
      getRequestItemsById: "v1/platform-fee/paid-request/{id}",
      platformFeeEnums: "v1/platform-fee/types/enums",
      updateFeeRequest: "v1/platform-fee/request/{id}",
      paymentIntent: "v1/webhooks/platform-fee/payment-intent",
      getPlatformFeeAmount:"v1/platform-fee/amount",
      createSetupIntent: "v1/platform-fee/billing/setup-intent",
      getCards: "v1/platform-fee/billing/cards",
      saveCard: "v1/platform-fee/billing/cards",
      setDefaultCard: "v1/platform-fee/billing/cards/{paymentMethodId}/default",
      deleteCard: "v1/platform-fee/billing/cards/{paymentMethodId}",
      getBillingSettings: "v1/platform-fee/billing/settings",
      updateBillingSettings: "v1/platform-fee/billing/settings",
      getCardTransactions: "v1/platform-fee/billing/transactions",
      getAdminCardTransactions: "v1/platform-fee/admin/transactions",
    },
    requestTypes: {
      getRequestTypesByOrgId: "v1/request-type/organization/{orgId}",
      getRequestTypeReferenceIds: "v1/request-type/reference-ids",
    },
    services: {
      getServicesReferenceIds: "v1/service/reference-ids",
    },
    xrayBodyParts: {
      getXrayBodyPartsReferenceIds: "v1/xray-body-parts/reference-ids",
      getXrayCategoryFee: "v1/configuration/accounts/field",
    },
    configuration: {
      getConfigurationByOrgId: "v1/configuration/organization/{orgId}",
    },
    serviceMapping: {
      getServiceMappingReferenceIds: "v1/service-mapping/reference-ids",
      getInvoiceServiceMapping: "v1/service-mapping/invoice-service-mapping",
    },
    organization: {
      getConfigurationByOrgId: "v1/organization-configuration/{orgId}",
      updateConfigurationByOrgId: "v1/organization-configuration/{orgId}",
      getRecordTypes: "v1/organization-record-types",
      updateRecordTypes: "v1/organization-record-types/bulk",
      toggleStatus: "v1/organizations/status/{id}/flags",
    },
    accounts: {
      getNextAccount:"v1/admin/accounts/nextacc",
      getPreviousAccount:"v1/admin//accounts/previousacc",
      nextAcc:"v1/admin/accounts/pending-sign-up/next",
      previousAcc:"v1/admin/accounts/pending-sign-up/previous",
      nextAccount: "v1/admin/accounts/nature/{nature}/next",
      previousAccount: "v1/admin/accounts/nature/{nature}/previous",
      getAccountDetailsByOrgId: "v1/organizations/{orgId}/account-details",
      getPendingFacilityCounts: "v1/admin/accounts/pending-facility-count",
      stripeSetupLink: "v1/stripe/stripe-setup-link",
      getConfigByAccountId: "v1/configuration/account/{id}",
      getProcessingById: "v1/accounts/user/backoffice-processing/{accountId}",
      getScanningAgentsById: "v1/accounts/user/backoffice-agent/{accountId}",
      deleteAccountWithDetails: "v1/admin/accounts/delete-account-details/{id}",
      getAllOrganizationsByAccountId: "v1/organizations/account/{accountId}",
    },
    customers: {
      getNextCustomer:"v1/customer/next",
      getPreviousCustomer:"v1/customer/previous",
      getActiveCustomerList: "v1/customer/active",
      getAllCustomerList: "v1/customer",
      createCustomers: "v1/customer",
      createPatientCustomer: "v1/customer/individual",
      createProfessionalCustomer: "v1/customer/company",
      getCustomerById: "v1/customer/{id}",
      updateCustomer: "v1/customer/{id}",
      getCustomerConfiguration: "v1/customer-configuration/{id}",
      getCustomerByAccountId:
        "v1/customer/requester/{requesterId}/processor/{processorId}",
      updateCustomerConfiguration: "v1/customer-configuration/customer/{id}",
    },
    documentRequest: {
      getDraftDetails: "v1/orders/drafts/detail/{draftId}",
      bulkSendFax: "v1/azure-job",
      updateOrderRequesterDetails: "v1/orders/{id}/requester-details",
      getOrdersbyDraftId: "v1/orders/order-draft/{id}",
      getServiceTypes: "v1/orders/service-type",
      saveService: "/v1/order-draft",
      updateServiceDraft: "/v1/order-draft/{orderDraftId}",
      saveApplicant: "v1/order-draft/{orderDraftId}/applicant-draft",
      updateApplicantDraft:
        "v1/order-draft/{orderDraftId}/applicant-draft/{id}",
      getOrderDetails: "/v1/orders",
      saveUploads: "v2/orders/order-draft/{orderDraftId}/files-draft",
      saveManualOrderUploads:
        "v1/order-draft/{orderDraftId}/files-draft/manual-order",
      getAuditEnums: "v1/order-draft/audit/enums",
      getOrderDraftById: "v1/order-draft/{id}",
      deleteOrderDraft: "v1/order-draft/{orderDraftId}",
      getOrderDetailsRequestProcessor:
        "/v1/orders/requestProcessor/order-details/{orderId}",
      getRequestInternalStatusEnums: "/v1/orders/request-internal-status/enums",
      getOrderSummaryById: "v1/orders/{id}",
      getInvoiceById: "v1/invoice/order/{id}",
      updateOrderStatus: "v1/orders/status",
      recordAdvanceFeePayment: "v1/payment/record-payment",
      recordPayment: "v1/orders/record-payment",
      createInvoicebyOrderDraft: "v1/orders/order-draft/invoice",
      createInvoicebyOrder: "v1/orders/invoice",
      updateOrder: "v1/orders/{id}/order-details",
      getRequesterCountsByStatus: "v1/orders/requester/count",
      getRequestProcessorCountByStatus: "v1/orders/requestProcessor/count",
      getOrderStatusLogsById: "v1/order-status-logs/order/{orderId}",
      getStripeAccountDetailsById: "v1/stripe/account-details/{id}",
      getrecordPaymentById: "v1/orders/{orderId}/invoice",
      getOrderById: "v1/orders/{id}",
      getPatientDetailsById: "v1/applicants/{id}",
      getInvoicesByOrderId: "v1/invoice/all/{id}",
      getFacilityDetailsByAccountId: "v1/organizations/account/{id}",
      getUserProfileById: "v1/users/profile/{id}",
      updateFacility: "v1/organizations/{id}",
      updatePatientDetails: "v1/applicants/{id}",
      updateUserProfile: "v1/users/{id}",
      createNotes: "v1/notes",
      getNotes: "v1/notes/order/{id}",
      updateRejectedOrderDetails: "v1/orders/{id}/details-resubmit",
      updateRejectedOrderFiles: "v1/orders/{id}/files-resubmit",
      deleteGeneratePdf: "v1/orders/finalPdf/{orderId}",
      getBulkAssignmentEnums: "v1/orders/bulk-assignment/enums",
      getBulkAssignmentOrders: "v1/orders/bulk-assignment/{status}",
      bulkAssignment: "v1/orders/bulk-assignment",
      passwordCheck: "v1/orders/passwordCheck",
      downloadFile: "v1/files/download/{id}/{orderId}",
      downloadFileWithOtpTrack: "v1/download-file-track/{id}/verification/{verificationId}",
      createDownloadFileTrack: "v1/file-password-otp/{orderId}/create-download-file-track",
      otpRequestDownloadFile: "v1/orders/{orderId}/files/{fileId}/request-download",
      downloadFileWithOtp: "v1/orders/download",
      downloadOtpLog:"v1/order-status-logs/otp-log",
      resendOtpRequestDocument: "v1/orders/{orderId}/files/{fileId}/resend-otp",
      requestPasswordPreviewOtp:
        "v1/file-password-otp/{orderId}/files/{fileId}/request-password-otp",
      verifyPasswordPreviewOtp:
        "v1/file-password-otp/{orderId}/files/{fileId}/verify-password-otp",
      resendPasswordPreviewOtp:
        "v1/file-password-otp/{orderId}/files/{fileId}/resend-password-otp",
      getProcessorSupportTicket: "v1/orders/getProcessorSupportTicket",
      getRequesterTickets: "v1/orders/getRequesterSupportTicket",
      updateRequestProcessort:
        "v1/orders/setProcessorSupportMessagesRead/{orderId}",
      setRequesterSupportMessagesRead:
        "v1/orders/setRequesterSupportMessagesRead/{orderId}",
      deleteOrderfiles: "v1/orders/file/{id}/{orderId}",
      getXrayFiles: "v1/orders/final-record/{orderId}/x-ray",
      revertRejectedOrder: "v1/orders/revert-rejected-order/{orderId}",
      revertCancelledOrder: "v1/orders/revert-cancelled-order/{orderId}",
      bulkEmailInvoice: "v1/orders/bulk-email-invoice",
      bulkSendInvoiceVia: "v1/orders/bulk-send-invoice-via",
      getRequesterTicketsCounts: "v1/orders/requesterSupportTicket/count",
      getProcessorTicketsCounts: "v1/orders/processorSupportTicket/count",
      getReminder:"v1/reminder",
      updateReminder:"v1/reminder/{id}",
      skipAdvanceFee: "v1/orders/skip-advance-fee/{orderId}",
      nextOrder: "v1/orders/nextOrder",
      requesterNextOrder:"v1/orders/requester/nextOrder",
      previousOrder: "v1/orders/previousOrder",
      requesterPreviousOrder:"v1/orders/requester/previousOrder",
      removeFee: "v1/orders/remove-fee/{orderId}/invoice/{invoiceId}/fee/{feeId}",
      getOrderDraftIdDetails: "v2/orders/order-draft/{orderDraftId}/summary",
      getOrderPaymentSummary: "v1/orders/{orderId}/payment-summary",
      getCheckRemittance: "v2/orders/{id}/check-remittance",
      checkNewRequestEligibility: "v2/orders/new-request-eligibility",
      confirmOrderDraftPayment: "v2/orders/order-draft/{orderDraftId}/confirm",
      createOrdersFromDraft: "v2/orders/order-draft/{orderDraftId}/create",
      draftOrders:"v1/orders/drafts/{requesterAccountId}",
    },
    orderLineItems: {
      createOrderLineItem: "v1/order-line-item/item",
      getOrderLineItemById: "v1/order-line-item/item/{id}",
      getLineItemsByOrderId: "v1/order-line-item/order/{orderId}/items",
      getOrderLineItemInvoice: "v1/order-line-item/invoice/items",
      submitOrderLineItem: "v1/orders/order-line-item/submit",
      saveOrderLineItemSelections: "v1/orders/order-line-item/selections",
    },
    invoice: {
      createXrayRecordPaymentInvoice: "v1/orders/invoice/record-payment/xray-breakdown",
      finalizeInvoice:"v1/orders/invoice/{invoiceId}/finalize",
      // SendEmail:"v1/orders/invoice/{invoiceId}/send",
      createInvoice: "v1/invoice",
      createDefaultInvoice: "v1/orders/defaultInvoice",
      deleteInvoice: "v1/orders/invoice/{invoiceId}/{orderId}",
      getAllInvoicewithOrders: "v1/invoice/orders",
      getInvoicetypeEnums: "v1/invoice/types/enums",
      getFeeTypeEnums: "v1/invoice/types/fee/enums",
      getAllInvoicesByOrderId: "v1/invoice/all/{id}",
      getAllPaidInvoicesByOrderId: "v1/invoice/paid/{id}",
      createInvoiceLineItem: "v1/orders/invoice/{invoiceId}/items",
      updateInvoiceLineItem: "v1/invoice/{invoiceId}/items/{id}",
      deleteInvoiceLineItem: "v1/invoice/{invoiceId}/items/{id}",
      sendEmailInvoice: "v1/orders/sendEmailInvoice/{invoiceId}",
      defaultInvoice: "v1/orders/defaultInvoice",
      createBillingInvoice: "v1/orders/billing/invoice",
      getRecordPayentInvoiceById: "v1/invoice/record-payment/{invoiceId}",
      createXrayInvoice: "v1/orders/invoice/xray-breakdown",
      getBulkUploadList: "v1/orders/requester-processor/range/status",
      getRecordUnpaid: "v1/orders/requester-processor/range/amount",
      changePaymentMode: "v1/orders/invoice/change-payment-mode",
      getInvoiceById: "v1/invoice/details/{invoiceId}",
      getInvoiceReceipts:"v1/receipts/invoice/{invoiceId}",
      applyDiscount: "v1/invoice/{invoiceId}/discount/apply",
    },
    uploads: {
      checkDuplicates: "v1/azure/check-duplicates",
      getSasToken: "v1/azure/sas-token/orderDraft",
      getFileEnums: "v1/order-draft/files/enums",
      notifyUploadSuccess: "v1/order-files",
      removeUploadedFile: "v1/order-files/{orderId}",
      getSasTokenOrder: "v1/azure/sas/order",
      getSasTokenBulk: "v1/azure/sas/bulk",
      deleteAzureFile: "v1/azure/sas",
      getDeclarationFile: "v1/files/declaration/{orderId}",
      createFiles: "v1/files",
      generatePDF: "v1/orders/generatePDF/{id}",
      getFilesView: "v1/azure/sas/read",
      getSaSTokenLogo: "v1/azure/logo",
      getAdminSaSTokenLogo: "v1/azure/admin/logo",
      getAdminHipaaSasToken: "v1/azure/sas-token/admin/hipaa",
      getHipaaSasToken: "v1/azure/sas-token/hipaa",
      getLineItems: "v1/invoice/lineItems/order/{orderId}",
      getPickedLineItems: "v1/invoice/lineItems/order/{orderId}/picked",
    },
    pageBuilder : {
      getTemplateTokens: "v1/page-builder-templates/{id}/upload-token",
      getEditVersionTemplate: "v1/page-builder-templates/{id}/edit-token",
      saveHTMLTemplate: "v1/page-builder-templates/uploadToken/html",
      saveJsonTemplateEntry: "v1/page-builder-templates",
      getAllTemplates: "v1/page-builder-templates",
      getById: "v1/page-builder-templates/{id}",
      deleteFile: "v1/page-builder-templates/{id}",
      saveAsDraft: "v1/page-builder-templates/{id}/save-draft",
      finalizeTemplate: "v1/page-builder-templates/{id}/finalize",
      saveTemplateVersion: "v1/page-builder-templates/{id}/save",
      cloneTemplate: "v1/page-builder-templates/clone",
      updateTemplate: "v1/page-builder-templates/{id}/update",
      activeTemplate: "v1/page-builder-templates/{id}/Active",
      inactiveTemplate: "v1/page-builder-templates/{id}/InActive",
      setDefaultTemplate: "v1/page-builder-templates/{id}/setDefault",
      deleteTemplateVersion: "v1/page-builder-templates/version/{id}",
      deleteTemplate: "v1/page-builder-templates/{id}",
    },
    bulkuploads: {
      createfilesbulkTask: "v1/bulk-file",
      getAllfilesbulkTask: "v1/bulk-file",
      getFilterData: "v1/bulk-file/filter",
    },
    signature: {
      getSasTokenSignature: "v1/azure/sas-token/signature",
    },
    resendSetPassword: "v1/users/resend-set-password/{id}",
    resendSetPasswordEmployee: "v1/users/resend-set-password/employee/{id}",
    notifications: "v1/notifications",
    notificationsUnreadCount: "v1/notifications/unread-count",
    notificationMarkRead: "v1/notifications/{id}/read",
    notificationsMarkAllRead: "v1/notifications/read-all",
    adminNotifications: "v1/admin/notifications",
    adminNotificationsUnreadCount: "v1/admin/notifications/unread-count",
    adminNotificationMarkRead: "v1/admin/notifications/{id}/read",
    adminNotificationsMarkAllRead: "v1/admin/notifications/read-all",
    superAdminNotifications: "v1/super-admin/notifications",
    superAdminNotificationsUnreadCount: "v1/super-admin/notifications/unread-count",
    superAdminNotificationMarkRead: "v1/super-admin/notifications/{id}/read",
    superAdminNotificationsMarkAllRead: "v1/super-admin/notifications/read-all",
  },
  websiteOpenServices: {
    contactUs: "websiteOpenservices/contactus",
  },
  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  APP_MODE: "Development",
  DOMAIN: "yopmail.com",
};

// Loading runtime configuration from azure portal -> configuration -> snippets
const envConfig =
  window.config && window.config.appConfig ? window.config.appConfig : {};

if (envConfig) {
  if (envConfig.pusher) {
    appConfig.pusher = { ...appConfig.pusher, ...envConfig.pusher };
  }
  if (envConfig.api) {
    appConfig.api = { ...appConfig.api, ...envConfig.api };
  }
  if (envConfig.payment) {
    appConfig.api = { ...appConfig.api, ...envConfig.api };
  }
}

export default appConfig;
